import React from 'react';

import { ClickableIcon } from '~components';
import { faXmark } from '~components/icon';
import { Row } from '~components/table-view';

interface ComponentProps {
  row?: Row;
  onRemovePair?: (row: Row) => void;
}

/**
 * Drops a replacement from the run being built in step 1 of the service cutover assistant.
 *
 * A column of its own rather than a row action: the pairs table is readonly - the rows are a record
 * of what was added, not something to be edited in place - and TableView drops its whole actions cell
 * in that mode, so `canDeleteRow`/`onDeleteRow` were inert and a mis-stated replacement could only be
 * cleared by closing the assistant and starting again.
 */
const CutoverPairRemoveAction: React.FC<ComponentProps> = ({ row, onRemovePair }) => (
  <div className="d-flex justify-content-center align-items-center w-100">
    <ClickableIcon
      id={`cutover-remove-pair-${row?.from_service_id}`}
      dataCy="cutover-remove-pair"
      icon={faXmark}
      toolTip="Remove this replacement"
      // The tooltip is portaled and names nothing to assistive technology, so an icon-only
      // role=button carries its own label - as every other icon in this assistant does.
      ariaLabel="Remove this replacement"
      onClick={() => row && onRemovePair?.(row)}
    />
  </div>
);

export default CutoverPairRemoveAction;
